import { myFetch, HttpMethod } from './baseService';

export interface TipoEncomienda {
  ten_codigo: string;
  ten_nombre: string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

/**
 * Obtener todos los tipos de encomienda
 */
export const obtenerTiposEncomienda = async () => {
  const envelope = await myFetch<ApiEnvelope<TipoEncomienda[]>>(
    'tipo_encomienda/ObtenerTodos',
    HttpMethod.POST,
    {}
  );
  return envelope;
};

